import React from 'react';
import styles from './currentlyPurchasedField.module.scss';
import { useMutation } from 'react-query';
import { toast } from 'react-toastify';
import ToggleButton from 'v2/common/ToggleButton/ToggleButton';
import restFactory from 'v2/utils/restFactory';
import { IamACustomerDRMEntityType, IamACustomerDrmEntity } from 'v2/models';
import { TranslationKeys } from 'translations';
import { useTranslation } from 'react-i18next';

interface CurrentlyACustomerMutateData {
  isACustomer: boolean;
}

export function useEntityMap() {
  const { t } = useTranslation();

  return {
    [IamACustomerDrmEntity.DATASET]: {
      property: 'currently_purchased',
      name: t(TranslationKeys.dataProduct_one),
      errorMessage: `Error saving currently purchase ${t(
        TranslationKeys.dataProduct_one
      )} field.`,
    },
    [IamACustomerDrmEntity.DATA_VENDOR]: {
      property: 'am_a_customer',
      name: t(TranslationKeys.dataProvider_one),
      errorMessage: 'Error saving I am a customer field.',
    },
  };
}

interface CurrentlyPurchasedProps {
  drmEntity: IamACustomerDRMEntityType;
  canEdit: boolean;
  onChange: (isACustomer: boolean) => void;
}

const CurrentlyPurchasedField = ({
  drmEntity,
  canEdit,
  onChange,
}: CurrentlyPurchasedProps) => {
  const entityMap = useEntityMap();

  const { isLoading, mutate } = useMutation(
    async (data: CurrentlyACustomerMutateData) => {
      return await restFactory.patch(
        `/dj/api/v1/${drmEntity.type}/${drmEntity.id}/`,
        { [entityMap[drmEntity.type].property]: data.isACustomer }
      );
    },
    {
      onSuccess: () => {
        onChange(!drmEntity.iAmACustomer);
      },
      onError: () => {
        toast.error(entityMap[drmEntity.type].errorMessage);
      },
    }
  );

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    mutate({ isACustomer: e.currentTarget.checked });
  };

  return (
    <div className={styles.currentlyPurchaseToggle}>
      <ToggleButton
        checked={drmEntity.iAmACustomer}
        onChange={handleChange}
        label={`I am currently a customer of this ${
          entityMap[drmEntity.type].name
        }`}
        ariaLabel="assignToMeBtn"
        labelTextClassName="black"
        disabled={isLoading || !canEdit}
      />
    </div>
  );
};

export default CurrentlyPurchasedField;
